// extracted by mini-css-extract-plugin
module.exports = {"column":"o5bmEpORG1wH15mfydZ2k"};